import { withSuspense } from "@spa/app/routes/withSuspense";
import type { RouteObject } from "react-router-dom";

const WelcomePage = withSuspense(
  () => import("@dust-tt/front/components/pages/onboarding/WelcomePage"),
  "WelcomePage"
);
const SubscribePage = withSuspense(
  () => import("@dust-tt/front/components/pages/onboarding/SubscribePage"),
  "SubscribePage"
);
const TrialPage = withSuspense(
  () => import("@dust-tt/front/components/pages/onboarding/TrialPage"),
  "TrialPage"
);
const SelectSubscriptionPage = withSuspense(
  () =>
    import("@dust-tt/front/components/pages/onboarding/SelectSubscriptionPage"),
  "SelectSubscriptionPage"
);
const TrialEndedPage = withSuspense(
  () => import("@dust-tt/front/components/pages/onboarding/TrialEndedPage"),
  "TrialEndedPage"
);
const ActivateFreePlanPage = withSuspense(
  () =>
    import("@dust-tt/front/components/pages/onboarding/ActivateFreePlanPage"),
  "ActivateFreePlanPage"
);
const CheckoutPage = withSuspense(
  () => import("@dust-tt/front/components/pages/onboarding/CheckoutPage"),
  "CheckoutPage"
);
const PaymentProcessingPage = withSuspense(
  () =>
    import("@dust-tt/front/components/pages/onboarding/PaymentProcessingPage"),
  "PaymentProcessingPage"
);

const OnboardingWizardPage = withSuspense(
  () =>
    import("@dust-tt/front/components/pages/onboarding/OnboardingWizardPage"),
  "OnboardingWizardPage"
);

// Onboarding routes inside workspace (paywall-whitelisted)
export const onboardingRoutes: RouteObject[] = [
  {
    path: "onboarding",
    element: <OnboardingWizardPage />,
    handle: { requireOnboardingComplete: false },
  },
  {
    path: "welcome",
    element: <WelcomePage />,
    handle: { requireCanUseProduct: false },
  },
  {
    path: "subscribe",
    element: <SubscribePage />,
    handle: { requireCanUseProduct: false },
  },
  {
    path: "trial",
    element: <TrialPage />,
    handle: { requireCanUseProduct: false },
  },
  {
    path: "select-subscription",
    element: <SelectSubscriptionPage />,
    handle: { requireCanUseProduct: false },
  },
  {
    path: "trial-ended",
    element: <TrialEndedPage />,
    handle: { requireCanUseProduct: false },
  },
  {
    path: "activate",
    element: <ActivateFreePlanPage />,
    handle: { requireCanUseProduct: false },
  },
  {
    path: "subscription/checkout",
    element: <CheckoutPage />,
    handle: { requireCanUseProduct: false },
  },
  {
    path: "subscription/payment_processing",
    element: <PaymentProcessingPage />,
    handle: { requireCanUseProduct: false },
  },
];
